module.exports = __webpack_public_path__ + "static/media/BottleBreak.d1a5f2b0.wav";